// extracted by mini-css-extract-plugin
export default {"QuestionContainer":"Question_QuestionContainer__iKtth","Line":"Question_Line__3bNUh"};